import { renderFragmentClient } from './fragmentClient';
renderFragmentClient();
